// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__amcU0","buttons":"SendReceipts_buttons__1YRnR","email":"SendReceipts_email__3ZvVY","bookApptTitle":"SendReceipts_bookApptTitle__3bOg1"};